import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(
  theme => ({
    accordionButton: {
      backgroundColor: 'white',
      borderRadius: 24,
      color: 'black',
      marginTop: 16,
      padding: 8,
      paddingInline: 32,
      textTransform: 'none',
      width: '60%'
    },
    accordionCaption: {
      fontSize: 22
    },
    accordionCaptionAccent: {
      color: '#0097EC',
      fontSize: 22,
      fontWeight: 'bold'
    },
    accordionCaptionContainer: {
      display: 'flex',
      flexDirection: 'column',
      margin: 40,
      margin: '0 auto',
      paddingLeft: 40,
      paddingTop: 40,
      textAlign: 'left',
      width: '50%',
      [theme.breakpoints.down('md')]: {
        paddingLeft: 0,
        width: '80%'
      }
    },
    accordionCaptionImage: {
      alignSelf: 'center',
      marginBottom: 8,
      width: '60%',
      [theme.breakpoints.down('md')]: {
        width: '80%'
      }
    },
    accordionColumn: {
      flex: 1
    },
    accordionContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: 56,
      marginBottom: 40,
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        padding: 32,
        marginBottom: 16
      }
    },
    accordionEmployersContainer: {
      flex: 1.2,
      paddingLeft: 56,
      paddingRight: 0,
      paddingTop: 40,
      [theme.breakpoints.down('md')]: {
        paddingBottom: 16,
        paddingLeft: 40,
        paddingRight: 40,
        paddingTop: 16
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 16,
        paddingRight: 16
      }
    },
    accordionEmployeesContainer: {
      flex: 1.2,
      paddingLeft: 0,
      paddingRight: 56,
      paddingTop: 40,
      [theme.breakpoints.down('md')]: {
        paddingBottom: 16,
        paddingLeft: 40,
        paddingRight: 40,
        paddingTop: 16
      }
    },
    accordionTitle: {
      marginBottom: 32,
      textAlign: 'left'
    },
    headerContainer: {
      marginBottom: 32,
      position: 'relative'
    },
    headerImage: {
      cursor: 'pointer',
      width: '100%'
    },
    programCardContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      padding: 40,
      width: '70%',
      [theme.breakpoints.down('md')]: {
        padding: 20,
        width: '100%'
      }
    },
    programContainer: {
      backgroundColor: '#1E4164',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        padding: 16
      }
    },
    programRow: {
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: 80,
      paddingRight: 80,
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        padding: 32
      }
    },
    programTextContainer: {
      alignItems: 'flex-start',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      paddingRight: 40,
      [theme.breakpoints.down('md')]: {
        alignItems: 'center'
      }
    },
    programTitle: {
      // fontSize: 40,
      lineHeight: 1.5,
      textAlign: 'left',
      [theme.breakpoints.down('md')]: {
        fontSize: 30,
        textAlign: 'center'
      }
    },
    redTitle: {
      color: '#F1645D',
      fontSize: 64,
      fontWeight: 'bold',
      paddingBottom: 56,
      paddingTop: 56,
      [theme.breakpoints.down('md')]: {
        fontSize: 24,
        paddingBottom: 32,
        paddingTop: 32
      }
    }
  }),
  { classNamePrefix: 'PayrollCards' }
)
